import React from 'react';

import IMAGES from '../../../constants/Images';
import { UnsupportedDeviceContainer } from './UnsupportedDevice.style';

/**
 * Shown when an AI interview is opened on a device where screen sharing is not
 * possible (mobile/tablet browsers and app webviews) and the interview is not
 * enabled for mobile.
 */
export default function UnsupportedDevice() {
  return (
    <UnsupportedDeviceContainer>
      <img
        className="unsupported-device-icon"
        src={IMAGES.NOT_SUPPORTED_ICON}
        alt="Interview not supported on this device"
      />
      <div className="unsupported-device-title">
        Interview not supported on this device
      </div>
      <div className="unsupported-device-message">
        This interview can only be taken on a desktop device. Please switch to a
        desktop or laptop to continue.
      </div>
    </UnsupportedDeviceContainer>
  );
}
